export default "__VITE_ASSET__Uu6$Er5a__"